import { legacyFormatFrenchDate } from "@/shared/utils/LegacyDates.ts";
import type { DisplayOptions } from "@/pages/human-resources/time-management/model/display-options/DisplayOptions.ts";
import {
  mapToTimeFormat,
  type ScheduleStateIn,
  type TimeFormatIn,
} from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/CommonParts";
import {
  mapFromArrangementAndOrder,
  type PrintArrangementIn,
} from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintArrangementIn.ts";
import type { ScheduleViewFilters } from "@/pages/human-resources/time-management/components/display-filters/provider/ScheduleViewFilters.ts";

export interface PrintMonthlyScheduleDetailsIn {
  date: string; // uses format: dd/MM/yyyy
  idSite: string;
  idsEmps: number[];
  timeFormat: TimeFormatIn;
  etat: ScheduleStateIn;
  withHeuresMajorees: boolean;
  arrangement: PrintArrangementIn;
}

export function inputForPrintMonthlyScheduleWithDetails(
  date: Date,
  siteId: string,
  employeesIds: string[],
  displayOptions: DisplayOptions,
  viewFilters: ScheduleViewFilters,
): PrintMonthlyScheduleDetailsIn {
  return {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    date: legacyFormatFrenchDate(date),
    idSite: siteId,
    idsEmps: employeesIds.map((s) => parseInt(s)),
    timeFormat: mapToTimeFormat(displayOptions.durationUnit),
    etat: "2",
    withHeuresMajorees: false, // Legacy front does not send this field (backend defaults to false)
    arrangement: mapFromArrangementAndOrder(
      viewFilters.viewArrangement,
      viewFilters.employeesOrder,
    ),
  };
}
